import { Pipe, PipeTransform } from '@angular/core';
import * as jalalimoment from "jalali-moment";
@Pipe({
  name: 'shamsiWithTime'
})
export class ShamsiWithTimePipe implements PipeTransform {

  transform(value: Date | string | null | undefined): string {
    if (!value) return 'نامشخص';

    const date = new Date(value);
    if (isNaN(date.getTime())) return 'تاریخ نامعتبر';

    const jalaliDate = jalalimoment(date).locale('fa').format('YYYY/M/D');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${jalaliDate} ${hours}:${minutes}`;
  }

}
